import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var UShapedIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M4.9 6.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM20.1 6.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM6 9.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM20.1 10.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM6 13.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM6.9 19.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2zM21.2 13.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM17.993 4.883A1 1 0 0016 5v6.857l-.005.216C15.9 14.285 14.342 16 12.5 16 10.599 16 9 14.173 9 11.857V5l-.007-.117A1 1 0 007 5v6.857l.004.234C7.114 15.35 9.502 18 12.5 18c3.07 0 5.5-2.778 5.5-6.143V5l-.007-.117zM19.2 18.1a1.1 1.1 0 11-2.2 0 1.1 1.1 0 012.2 0zM12.5 21.2a1.1 1.1 0 100-2.2 1.1 1.1 0 000 2.2z"
                    })
                })
            })
        ]
    });
};
UShapedIcon.isCarinaIcon = true;
export default UShapedIcon;
